import ajax from '../ajax'

//登陆
export function loginApi(data) {
    return ajax({
        url: '/v2/admin/login',
        data
    })
}
//退出登陆
export function outLoginApi(data) {
    return ajax({
        url: 'v2/admin/logout',
        data
    })
}





// WEBPACK FOOTER //
// ./src/apis/loginApi/index.js